<template>
    <div class="person">
        <div class="person-topicon">
            人物档案
        </div>
        <div class="person-content">
            <!-- 人物信息内容 没有题目信息的margintop用mar-top5，有的话用mar-top2-->
            <div :class="['personinfo', hasQuestion ? 'mar-top11' : 'mar-top5']">
                <img class="left-img" :src="swCharacterInfo.characterHeadImageUrl" alt="">
                <div class="center-content">
                    <div class="info word">
                        姓&emsp;&emsp;名：
                    </div>
                    <div class="info hei-085 word">
                        基本信息：
                    </div>
                    <div class="info word">
                        性&emsp;&emsp;格：
                    </div>
                </div>
                <div class="right-content">
                    <div class="info word">
                        {{swCharacterInfo.characterName}}
                    </div>
                    <div class="info hei-085 word">
                        {{swCharacterInfo.characterBaseInfo}}
                    </div>
                    <div class="info word">
                        {{swCharacterInfo.characterPersonality}}
                    </div>
                </div>
            </div>
            <!-- 分割线 -->
            <div class="line" v-if="hasQuestion"></div>
            <!-- 题目信息 -->
            <div class="topic" v-if="hasQuestion">
                <div class="topicinfo">
                    {{swCharacterInfo.txt}}
                </div>
                <img
                    class="play"
                    src="https://g.gsxcdn.com/2529839270_h1m6kcwv.png"
                    alt=""
                    srcset=""
                    @click="handleClickPlayBtn"
                >
            </div>
        </div>
    </div>
</template>
<script lang="js">
import {Options, Vue} from 'vue-class-component';

@Options({
    created() {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        swCharacterInfo() {
            return this.pageData.opusHistoryInfo?.swCharacterInfo;
        },
        hasQuestion() {
            // 配置了开放式语音题且用户有答题才展示该模块
            const {txt, audio, voiceUrl} = this.pageData.opusHistoryInfo?.swCharacterInfo;
            return txt && audio && voiceUrl;
        }
    },
    unmounted() {
        this.audioel?.pause();
    },
})
export default class Single extends Vue {
    // 用户是否点击了播放按钮
    isPlayAudio = false;
    audioel = null;

    // 点击播放按钮
    handleClickPlayBtn() {
        if (this.isPlayAudio) {
            return;
        }
        // 捕获是否有正在播放的视频，有的话全部停掉
        const allVideos = document.querySelectorAll('.oss-work-video');
        const arr = [...allVideos];
        arr.forEach(item => {
            item.pause();
        });

        // 播放题目语音
        this.playTiganAudio(this.swCharacterInfo.voiceUrl);
    }

    // 播放选项音频
    playTiganAudio(url) {
        this.isPlayAudio = true;
        this.audioel = new Audio(url);
        this.audioel.play();
        // 捕获音频播放失败做兼容处理
        this.audioError(this.audioel, () => {
            this.isPlayAudio = false;
        });
    }

    // 语音播放错误事件
    audioError(el, callback) {
        el.addEventListener('emptiedNew', () => {
            // 当媒介资源元素突然为空时（网络错误、加载错误等）运行脚本
            callback && callback();
        });
        el.addEventListener('error', err => {
            // 当在元素加载期间发生错误时运行脚本
            callback && callback();
        });
        el.addEventListener('stalled', () => {
            // 当取回媒介数据过程中（延迟）存在错误时运行脚本
            callback && callback();
        });
        el.addEventListener('ended', err => {
            // 播放完成
            callback && callback();
        });
    }
}
</script>

<style lang="scss" scoped>
.person {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 1.07rem;
    width: 7.76rem;
    height: 4.59rem;
    background: #FFFFFF;
    box-shadow: 0 .08rem .19rem 0 #5DBE5C;
    border-radius: .32rem;

    &-topicon {
        width: 2.43rem;
        height: .64rem;
        background: url('https://g.gsxcdn.com/2529665799_uz5f771c.png') 0 0 no-repeat;
        background-size: 100% 100%;
        padding: .08rem 0 .08rem .32rem;
        box-sizing: border-box;
        font-weight: 400;
        font-size: .37rem;
        color: #A6481B;
        line-height: .48rem;
        font-style: normal;
    }

    &-content {
        width: 100%;

        .mar-top5 {
            margin-top: .5rem;
        }

        .mar-top11 {
            margin-top: .11rem;
        }

        .personinfo {
            width: 100%;
            display: flex;

            .left-img {
                width: 1.92rem;
                height: 1.92rem;
                border-radius: .32rem;
                margin: .19rem .4rem 0 .43rem;
            }

            .word {
                font-weight: 400;
                font-size: .32rem;
                color: #333333;
                line-height: .43rem;
                font-style: normal;
            }

            .hei-085 {
                height: .85rem;
            }

            .center-content {
                .info {
                    width: 1.6rem;
                    margin-bottom: .27rem;
                }
            }

            .right-content {
                width: 3.04rem;

                .info {
                    margin-bottom: .27rem;
                }
            }
        }

        .line {
            margin-left: .3rem;
            width: 7.28rem;
            height: .03rem;
            box-sizing: border-box;
            border: .03rem solid #F6F7FB;
            margin-bottom: .16rem;
        }

        .topic {
            display: flex;
            margin-left: .43rem;

            .topicinfo {
                width: 5.95rem;
                height: .96rem;
                font-weight: 400;
                font-size: .37rem;
                color: #333333;
                line-height: .48rem;
                text-align: left;
                display: flex;
                align-items: center;
            }

            .play {
                width: 1.01rem;
                height: 1.01rem;
                margin-left: .08rem;
            }
        }
    }
}
</style>
